import React from 'react';
import { Link } from 'react-router-dom';

const PHONE = '0948082110';
const ZALO_URL = `https://zalo.me/${PHONE}`;

// Cột link: `to` = trang trong app (Link), `href` = mục trên trang chủ (/#...) hoặc link ngoài
const COLUMNS = [
    {
        title: 'Sản phẩm',
        links: [
            { label: 'Tính năng', href: '/#features' },
            { label: 'App iPhone & Android', href: '/#app' },
            { label: 'Zalo Bot cho HLV', href: '/#zalo' },
            { label: 'Hỏi đáp', href: '/#faq' },
        ],
    },
    {
        title: 'Phụ huynh & võ sinh',
        links: [
            { label: 'Cổng phụ huynh', to: '/tra-cuu-phu-huynh' },
            { label: 'Tra cứu mã VTF', to: '/cong-cu/tra-cuu-vtf' },
            { label: 'Tra cứu kết quả thi', to: '/cong-cu/tra-cuu-ket-qua-thi' },
        ],
    },
    {
        title: 'Hỗ trợ',
        links: [
            { label: 'Hướng dẫn sử dụng', to: '/huong-dan-su-dung' },
            { label: 'Cộng đồng Võ sư', to: '/cong-dong-vo-su' },
            { label: 'Trạng thái hệ thống', to: '/trang-thai-he-thong' },
            { label: 'Liên hệ', to: '/lien-he' },
        ],
    },
    {
        title: 'Công cụ miễn phí',
        links: [
            { label: 'Tất cả công cụ', to: '/cong-cu' },
            { label: 'Tạo mã QR vĩnh viễn', to: '/cong-cu/tao-ma-qr' },
            { label: 'Vòng quay may mắn', to: '/cong-cu/vong-quay-may-man' },
        ],
    },
];

const linkClass = 'hover:text-accent transition-colors';

const FooterLink = ({ label, to, href }) =>
    to ? (
        <Link className={linkClass} to={to}>
            {label}
        </Link>
    ) : (
        <a className={linkClass} href={href}>
            {label}
        </a>
    );

const ZaloMark = () => (
    <svg viewBox="0 0 48 48" className="h-5 w-5" aria-hidden="true">
        <rect width="48" height="48" rx="12" fill="currentColor" />
        <text x="24" y="29.5" textAnchor="middle" fontFamily="Arial, Helvetica, sans-serif" fontWeight="800" fontSize="15" fill="#fff">
            Zalo
        </text>
    </svg>
);

const LandingFooter = () => {
    return (
        <footer className="border-t border-slate-200 bg-slate-50 py-14 dark:border-slate-800 dark:bg-background-dark sm:py-16">
            <div className="mx-auto grid max-w-7xl grid-cols-2 gap-10 px-6 md:grid-cols-4 lg:grid-cols-6">
                <div className="col-span-2">
                    <div className="mb-5 flex items-center gap-2">
                        <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-white">
                            <span className="material-symbols-outlined text-sm">sports_martial_arts</span>
                        </div>
                        <span className="text-xl font-bold text-primary dark:text-white">1MS</span>
                    </div>
                    <p className="mb-6 max-w-xs text-slate-500 dark:text-slate-400">
                        Phần mềm quản lý võ đường Taekwondo: võ sinh, điểm danh, học phí, thi lên đai — trên app và web.
                    </p>
                    <div className="flex gap-3">
                        <a
                            href={`tel:${PHONE}`}
                            aria-label="Gọi tư vấn"
                            className="flex h-10 w-10 items-center justify-center rounded-full bg-white text-primary shadow-sm transition-all hover:bg-accent hover:text-white">
                            <span className="material-symbols-outlined text-xl">call</span>
                        </a>
                        <a
                            href={ZALO_URL}
                            target="_blank"
                            rel="noreferrer"
                            aria-label="Nhắn Zalo"
                            className="flex h-10 w-10 items-center justify-center rounded-full bg-white text-[#0068FF] shadow-sm transition-all hover:bg-[#0068FF] hover:text-white">
                            <ZaloMark />
                        </a>
                    </div>
                </div>
                {COLUMNS.map((col) => (
                    <div key={col.title}>
                        <h4 className="mb-5 font-bold text-primary dark:text-white">{col.title}</h4>
                        <ul className="space-y-3.5 text-sm text-slate-500 dark:text-slate-400">
                            {col.links.map((l) => (
                                <li key={l.label}>
                                    <FooterLink {...l} />
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
            <div className="mx-auto mt-14 flex max-w-7xl flex-col items-center justify-between gap-4 border-t border-slate-200 px-6 pt-8 dark:border-slate-800 md:flex-row">
                <p className="text-sm text-slate-500">© {new Date().getFullYear()} 1MS. Mọi quyền được bảo lưu.</p>
                <div className="flex gap-6">
                    <Link className="text-sm text-slate-500 hover:text-accent" to="/chinh-sach-bao-mat">
                        Chính sách bảo mật
                    </Link>
                    <Link className="text-sm text-slate-500 hover:text-accent" to="/dieu-khoan-su-dung">
                        Điều khoản sử dụng
                    </Link>
                </div>
            </div>
        </footer>
    );
};

export default LandingFooter;
